import React, { useState } from 'react';
import { Btn, Input } from '../components/UI';

export default function LoginScreen({ t, onLogin }) {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [mode, setMode] = useState('member');
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    setLoading(true);
    setTimeout(() => { setLoading(false); onLogin(mode === 'admin'); }, 800);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: t.isDark ? '#020305' : 'linear-gradient(160deg,#1B5E20,#2E7D32)', padding: 20, fontFamily: 'Nunito, sans-serif' }}>
      <div style={{ background: t.surface, borderRadius: 20, padding: '32px 28px', width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: t.isDark ? '#040f08' : '#1B5E20', border: `3px solid ${t.gold}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 900, color: t.isDark ? '#81C784' : '#fff', margin: '0 auto 14px', boxShadow: `0 0 20px ${t.gold}33` }}>SB</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: t.text }}>Welcome back</div>
          <div style={{ fontSize: 13, color: t.textHint, marginTop: 3, fontWeight: 600 }}>Login to SB Group</div>
        </div>
        {/* Mode selector */}
        <div style={{ display: 'flex', background: t.surface2, borderRadius: 10, padding: 3, marginBottom: 20, border: `0.5px solid ${t.border}` }}>
          {['member', 'admin'].map(m => (
            <div key={m} onClick={() => setMode(m)} style={{ flex: 1, textAlign: 'center', padding: '8px 0', borderRadius: 8, cursor: 'pointer', background: mode === m ? t.primary : 'transparent', color: mode === m ? '#fff' : t.textSec, fontSize: 13, fontWeight: 800, transition: 'all 0.2s', textTransform: 'capitalize' }}>{m}</div>
          ))}
        </div>
        <Input t={t} label="Email address" value={email} onChange={setEmail} placeholder="your@email.com" type="email" />
        <Input t={t} label="Password" value={pass} onChange={setPass} placeholder="••••••••" type="password" />
        <div style={{ textAlign: 'right', marginTop: -6, marginBottom: 20 }}>
          <span style={{ fontSize: 12, color: t.primary, fontWeight: 700, cursor: 'pointer' }}>Forgot password?</span>
        </div>
        <Btn t={t} label={loading ? 'Logging in...' : `Login as ${mode === 'admin' ? 'Admin' : 'Member'}`} onClick={handleLogin} disabled={loading} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '16px 0' }}>
          <div style={{ flex: 1, height: 1, background: t.border }} />
          <span style={{ fontSize: 12, color: t.textHint, fontWeight: 600 }}>or</span>
          <div style={{ flex: 1, height: 1, background: t.border }} />
        </div>
        <div style={{ background: t.primaryLight, border: `0.5px solid ${t.borderLight}`, borderRadius: 12, padding: '14px', textAlign: 'center', cursor: 'pointer' }}>
          <div style={{ fontSize: 24, marginBottom: 5 }}>👆</div>
          <div style={{ fontSize: 14, fontWeight: 800, color: t.primary }}>Fingerprint / Face ID</div>
          <div style={{ fontSize: 11, color: t.textSec, marginTop: 2, fontWeight: 500 }}>Quick secure login</div>
        </div>
        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: t.primary, fontWeight: 700, cursor: 'pointer' }}>No account? Register →</div>
      </div>
    </div>
  );
}
